export class AnulacionSecuenciaENCF {
  static get PROPIEDADES_EXPORTAR() {
    return [
      { value: "IdSec", label: "Id" },
      { value: "CantidadeNCFAnulados", label: "Cantidad de e-NCF Anulados" },
      { value: "_EstadoDesc", label: "Estado" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ]
  }
}